// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { objectToParams, apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { DokumenKerjasamaListResponse } from "./types";
import * as dokumenKerjasamaActions from "./dokumenKerjasama.actions";

export function* getDokumenKerjasama(
  action: ReturnType<typeof dokumenKerjasamaActions.getDokumenKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const departmentId = action.payload.department;
    delete action.payload.department;
    const url = BASE_URL + 'dokumen' + objectToParams(action.payload);
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: DokumenKerjasamaListResponse = yield call(result.json.bind(result));
      if (departmentId && departmentId !== '0000000000') {
        parsed.data.items = parsed.data.items.filter(item => {
          return item.DEPT_ID.includes(departmentId);
        });
      }
      yield put(dokumenKerjasamaActions.getDokumenKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(dokumenKerjasamaActions.getDokumenKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(dokumenKerjasamaActions.getDokumenKerjasamaAsync.failure(parsed));
  }
}

export default function* dokumenKerjasamaSagaGetDokumenKerjasama() {
  yield takeEvery(dokumenKerjasamaActions.getDokumenKerjasamaAsync.request, getDokumenKerjasama);
}
